module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CNF"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_c('a', {
    attrs: {
      "id": "pg_1"
    }
  }, [_vm._v("PROLOGUE")])])]), _c('a', {
    attrs: {
      "id": "pg_1"
    }
  }, [_c('p', {
    staticClass: "CT"
  }, [_vm._v("Condorcet’s Dream")]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("The application of the arithmetic of combinations and probabilities to [moral and political] sciences, promises an improvement by so much the more considerable, as it is the only means of giving to their results an almost mathematical precision, and of appreciating their degree of certainty or probability.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—MARQUIS DE CONDORCET (1743–1794), ")]), _c('span', {
    staticClass: "SC-I"
  }, [_vm._v("SKETCH FOR A HISTORICAL PICTURE OF THE PROGRESS OF THE HUMAN MIND")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("A mathematical theory begins with explicit assumptions, known as axioms, and follows their logical consequences. Thus plane geometry begins with axioms like “Two points define a unique straight line” and arrives at statements like “In a right triangle, the squares on the two sides are together equal to the square of the hypotenuse.” What we or our forebears believed to be true is irrelevant: mathematics requires us to abandon tradition and common sense, and use only logic.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Human societies, on the other hand, are usually based on tradition and common sense. For millennia, it was common sense that the vast majority of the population was incapable of ruling itself; it was common sense that certain people were fit only for slavery; it was common sense that women should be denied a voice in the political process. And so, by tradition, these beliefs and practices were perpetuated.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "pg_1"
    }
  }, [_vm._v("During the eighteenth century, a new idea emerged: societies should be based on logic and reason, not tradition and common sense. The American Revolution began against this backdrop; indeed, the Declaration of Independence reads like a mathematical treatise. “We hold these truths to be self-evident” begins a list of explicit axioms, such as “All men are created equal” and “All men have the right to life, liberty, and the pursuit of happiness.” From ")]), _c('a', {
    attrs: {
      "id": "pg_2"
    }
  }, [_vm._v("these, the Founders argued that rebellion against Great Britain was a necessary logical consequence of the actions of George III.")])]), _c('a', {
    attrs: {
      "id": "pg_2"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Unfortunately, the Founders chose to model the government of the new country on the government of the old country: a victory of common sense and tradition over reason and logic. When the Articles of Confederation proved incapable of governing the new country, a Constitutional Convention met and produced our present Constitution—another form of government based on common sense and tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fortunately, the Framers of the Constitution realized that they did not have all answers to all questions for all time. Consequently, although the Constitution requires the existence of certain institutions, such as the census, the electoral college, and jury trials, it left the details to the legislative branch of the government, with oversight by the executive and judicial branches.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The problem is that Congress operates by passing laws, leaving it to the president and the U.S. Supreme Court, and ultimately the court of public opinion, to decide whether the law is a good one. As a result, badly conceived laws persist, and unless they are reviewed and overturned, they continue to cause harm to all who live under them. Every day a bad law remains in force, it undermines faith in the rule of law—with potentially catastrophic results. Every effort must be made, then, to assess legislation before it is implemented and to continuously assess it while it remains in force.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This can be done in two ways. First, we might rely on tradition to assess legislation before it is passed and on common sense to evaluate it. Tradition says that what worked in the past will work today; thus what worked in mostly agrarian, mostly rural eighteenth-century America should work in mostly industrial, mostly urban twenty-first-century America; what worked in the age of flintlocks and sabers will work in the age of machine guns and sarin; what worked when most of a population of three million were white persons of European descent will work when most of a population of three hundred million are not. As for a law’s effectiveness, it is common sense that the census must be an exact to-the-person count; that the electoral college distorts the popular vote; and that draconian punishments deter crime.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The other approach is through the reason and logic espoused by Enlightenment philosophers like the Marquis de Condorcet. In his "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Essay on the Application of Probability to Decisions Made by a Plurality of Votes")]), _vm._v(" (1785), Condorcet gave expression to a dream: Mathematics can tell us how to build a better society.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "pg_2"
    }
  }), _c('a', {
    attrs: {
      "id": "pg_3"
    }
  }, [_vm._v("First, mathematics allows us to predict what would happen if we changed the very foundations of society, to answer the “What if” question that is the origin of all reform. What if we used proper statistical methods to conduct a census instead of trying to obtain a to-the-person exact count? What if we abandon the electoral college and substitute a direct popular vote? What if we replace the 12-person jury with a 3-person tribunal?")])]), _c('a', {
    attrs: {
      "id": "pg_3"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Next, we can continuously assess the effectiveness of our societal institutions in an objective fashion. For decades, the debate over capital punishment focused on whether it was morally justified; whether the United States should remain in the same club as North Korea and Iran; whether society should continue to feed, house, and clothe convicted murderers. And for decades, capital punishment persisted. It was not until the opponents of capital punishment enlisted the help of mathematics that they won a national moratorium from 1972 to 1976; and even though capital punishment returned in 1976, the philosophers, aided by mathematics, have managed to repeal capital punishment in eight states.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "pg_3"
    }
  }, [_vm._v("In the following chapters,"), _c('span', {
    staticClass: "ePub-SUP"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_prologue-1",
      "id": "prologue-1"
    }
  }, [_vm._v("1")]), _vm._v(" we shall see what mathematics has to say about the institutions required by the Constitution but designed by lawmakers, and the limitations on government embodied in the Bill of Rights. In some cases, mathematics supports the paths suggested by tradition and common sense. In others, it shows us a better way. In all cases, we ignore the findings of mathematics at our peril.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FN"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#prologue-1",
      "id": "fn_prologue-1"
    }
  }, [_vm._v("1")]), _vm._v(". Note: The book’s chapters are numbered based on the article and section of the U.S. Constitution, so, for example, "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2.1")]), _vm._v(" is about Article 2, Section 1 (concerning the election of the president), and "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter A4.1")]), _vm._v(" is about Amendment 4 (concerning the freedom from unreasonable search and seizure).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 81
// module chunks = 0